var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"SearchBox form-inline"},[_c('input',{staticClass:"form-control mr-sm-2",attrs:{"type":"text","placeholder":("Search " + _vm.name)},on:{"input":_vm.onChange}}),_vm._v("\n  "+_vm._s(_vm.search)+"\n  "),(_vm.showButton)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("Search")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0caae836","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchBox/searchbox.vue
// module id = null
// module chunks = 